import { OrderDetails } from '@savgroup-front-common/types';

import { adaptProductsEligibility } from './adapters/adaptProductsEligibility';

interface GetEligibleProductsCountArgs {
  orderDetails: (OrderDetails | undefined)[];
  eligibleOwnerProductIds?: string[];
}

export const getEligibleProductsCount = ({
  orderDetails,
  eligibleOwnerProductIds,
}: GetEligibleProductsCountArgs): number =>
  orderDetails.reduce((count, orderDetail) => {
    if (!orderDetail) {
      return count;
    }

    const { eligibleProducts } = adaptProductsEligibility({
      products: orderDetail.products,
      eligibleOwnerProductIds,
    });

    return count + eligibleProducts.length;
  }, 0);
